import { useState } from 'react';
import { Button, ButtonTheme } from '@apply/components';
import { SelectDrawUserModal } from '../../../../../SelectDrawUserModal/SelectDrawUserModal';

export interface AddUserButtonProps {
    propertyId: number;
    onRefresh: () => void;
}

export const AddUserButton: React.FC<AddUserButtonProps> = ({ propertyId, onRefresh }) => {
    const [linkGCUserToPropertyOpen, set_linkGCUserToPropertyOpen] = useState<boolean>(false);

    const onCloseLinkGCUserToProperty = () => {
        set_linkGCUserToPropertyOpen(false);
    };

    const onOpenLinkGCUserToProperty = () => {
        set_linkGCUserToPropertyOpen(true);
    };

    if (!propertyId) {
        return;
    }

    return (
        <>
            <Button
                id={`addUserButton_${propertyId}`}
                theme={ButtonTheme.Secondary}
                height='28px'
                width='150px'
                handleClick={onOpenLinkGCUserToProperty}
            >
                Add User
            </Button>
            <SelectDrawUserModal
                propertyId={propertyId}
                isOpen={linkGCUserToPropertyOpen}
                isEdit={false}
                onClose={onCloseLinkGCUserToProperty}
                onSaved={onRefresh}
            />
        </>
    );
};
